import { render } from "./TermsAndConditionsModal.vue?vue&type=template&id=68ff1d25&scoped=true"
import script from "./TermsAndConditionsModal.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsModal.vue?vue&type=script&lang=js"

import "./TermsAndConditionsModal.vue?vue&type=style&index=0&id=68ff1d25&lang=scss&scoped=true"
import "./TermsAndConditionsModal.vue?vue&type=style&index=1&id=68ff1d25&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ff1d25"]])

export default __exports__